import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MatchMiaiHint extends BasePopUpLayer {

    @property({type:cc.Node,displayName:"提示按钮"})
    hintBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"答案按钮"})
    answerBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"提示文本"})
    hintLabelNode:cc.Node = null;

    @property({type:cc.Node,displayName:"答案文本"})
    answerLabelNode:cc.Node = null;

    isGetHint:boolean = false;

    initLayout(){
        this.hintBtn.active = true;
        this.answerBtn.active = true;
        this.hintLabelNode.active = false;
        this.answerLabelNode.active = false;
    }

    onLoad(): void {
        this.initLayout();   
    }

    onBtnHint(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.hintBtn.active = false;
            this.hintLabelNode.active = true;
            this.isGetHint = true;
        },()=>{},null,"击败武林盟主看广告获得提示");
    }

    onBtnAnswer(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(!this.isGetHint){
            O1HD.getModules().uiControlModule.showMessageBox("请先解锁提示");
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.answerBtn.active = false;
            this.answerLabelNode.active = true;
        },()=>{},null,"击败武林盟主看广告获得答案");
    }

    onBtnLose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeUI();
        this._carryData.parent.openResult(false);
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeUI();
    }

    closeUI() {
        this.destroyNode();
        if (this._carryData.onComplete) {
            this._carryData.onComplete();
        }
    }

}
